import "./PlotsSharedLegend.scss"

type Props = {
    availableSeries: Map<string, LegendSerie>,
    orientation: "vertical" | "horizontal"
    serieSetVisibility: (name: string, active: boolean) => void
    title?: string
}

export type LegendSerie = {
    name: string;
    color: string;
    active: boolean;
    showLegend?: boolean;
    controlledSeries: string[];
}

const PlotsSharedLegend = (props: Props) => {
    let flexDirection = props.orientation === 'horizontal' ? " flex-row justify-content-between" : " flex-column justify-content-start";
    
    return (
        <>
            {props.title ? <h4 className="plotsSharedLegendTitle">{props.title}</h4> : null}
            <div className={"plotsSharedLegend flex flex-nowrap" + flexDirection }>
                {Array.from(props.availableSeries.values()).filter(s => s.showLegend ?? true).map(serie => 
                    <div className={"flex flex-row align-items-center justify-content-center legendSerieSwitch" + (serie.active ? " active" : "")} onClick={() => props.serieSetVisibility(serie.name, !serie.active)} key={serie.name}>
                        <div className="serieColorSquare" style={serie.active ? {
                            borderColor: serie.color,
                            backgroundColor: serie.color
                        }:{
                            borderColor: serie.color
                        }} />
                        <div className="serieName">{serie.name}</div>
                    </div>)}
            </div>
        </>
    );
}

export default PlotsSharedLegend;